import { ROUTES } from '@/shared/constants/routes';
import { useAppSelector } from '@/shared/hooks/useStore';
import { useWorkspaceQuery } from '@/viewmodel/features/workspace';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace';
import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

export function ProtectedRouteWorkspace({ children }: Readonly<{ children: ReactNode }>) {
  const currentWorkspace = useAppSelector(selectCurrentWorkspace);
  const [params] = useSearchParams();
  const w = params.get('w');
  const { workspaces, isSettled } = useWorkspaceQuery();

  if (currentWorkspace) return <>{children}</>;
  if (w && (!isSettled || workspaces.some((workspace) => workspace.id === w))) {
    return <>{children}</>;
  }
  return <Navigate to={ROUTES.WORKSPACES} />;
}
